import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { UtilsService } from '@app/providers/utils/utils.service';
import { EaEstateLoanFormService } from '../ea-estate-loan-form/ea-estate-loan-form.service';
import { EaEstimationFormService } from '../ea-estimation-form/ea-estimation-form.service';
import { EaFeesFormService } from '../ea-fees-form/ea-fees-form.service';
import { EaRealestateFormService } from '../ea-realestate-form/ea-realestate-form.service';

@Injectable({
  providedIn: 'root',
})
export class EaEstatesFormService {
  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected utilsService: UtilsService,
    protected eaEstimationFormService: EaEstimationFormService,
    protected eaRealestateFormService: EaRealestateFormService,
    protected eaEstateLoanFormService: EaEstateLoanFormService,
    protected eaFeesFormService: EaFeesFormService,
  ) {}

  public generate(entity: any) {
    let options: AbstractControlOptions = {};
    if (!entity) entity = {};
    let mainLoan: any = undefined;
    if (entity && entity.loans && entity.loans[0]) mainLoan = entity.loans[0];
    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null, Validators.nullValidator],
        personalUseType: [
          entity ? entity.personalUseType : null,
          Validators.required,
        ],
        userId: [entity ? entity.userId : null, Validators.nullValidator],
        accountId: [entity ? entity.accountId : null, Validators.nullValidator],
        typeUrl: [entity ? entity.typeUrl : null, Validators.nullValidator],
        realestate: this.eaRealestateFormService.generate(entity),
        loans: this.eaEstateLoanFormService.generate(
          mainLoan || { accountId: entity.accountId },
        ),
        fees: this.eaFeesFormService.generate(entity),
        estimations: this.eaEstimationFormService.generate(entity),
      },
      options,
    );
  }

  public extract(form: UntypedFormGroup, nestedForms?) {
    let realestate = form.get('realestate').value;

    let dto = {
      typeUrl: this.utilsService.emptyIsNull(form.value.typeUrl),
      id: this.utilsService.emptyIsNull(form.value.id),
      personalUseType: this.utilsService.emptyIsNull(
        form.value.personalUseType,
      ),
      label: this.utilsService.emptyIsNull(realestate.label),
      purchasePrice: this.utilsService.emptyIsNull(realestate.purchasePrice),
      startDate: this.utilsService.toIsoDate(realestate.startDate),
      subscriptionSource: this.utilsService.emptyIsNull(
        realestate.subscriptionSource,
      ),
      subscriptionSourceDetail: this.utilsService.emptyIsNull(
        realestate.subscriptionSourceDetail,
      ),
      property: {
        type: this.utilsService.emptyIsNull(realestate.residenceType),
        areaSize: this.utilsService.emptyIsNull(realestate.areaSize),
        street: this.utilsService.emptyIsNull(realestate.address.street),
        zipCode: this.utilsService.emptyIsNull(realestate.address.zipCode),
        city: this.utilsService.emptyIsNull(realestate.address.city),
        country: this.utilsService.emptyIsNull(realestate.address.country),
      },
      expenses: form.get('fees').value.fees,
      estimations: form.get('estimations').value.array,
      loans: this.eaEstateLoanFormService.extract(
        form.get('loans') as UntypedFormGroup,
      ),
    };
    console.debug(dto);
    return dto;
  }
}
